import { route } from 'preact-router';

export function NotFoundPage() {
  return (
    <div class="flex min-h-screen items-center justify-center bg-gray-100">
      <div class="card text-center">
        <h1 class="mb-4 text-4xl font-bold text-gray-800">404</h1>
        <p class="mb-6 text-gray-600">페이지를 찾을 수 없습니다</p>
        <button onClick={() => route('/')} class="btn btn-primary">
          홈으로 이동
        </button>
      </div>
    </div>
  );
}
